export const UPLOAD_CHOICES = Object.freeze({ FILE: 'file', ASSET: 'asset' });
